<template>
  <div class="account-management container-style">
    <el-card class="searchCard" shadow="never">
      <el-form :inline="true" :model="searchForm" class="form-inline">
        <el-form-item label="姓名:">
          <el-input v-model="searchForm.userName" placeholder="员工姓名"></el-input>
        </el-form-item>
        <el-form-item label="创建时间:">
          <datePicker @change="dateChange" :vModel="createTime" v-model="createTime"></datePicker>
        </el-form-item>
         <el-form-item label="账号:">
          <el-input v-model="searchForm.userAccount" placeholder="员工账号"></el-input>
        </el-form-item>
        <el-form-item label="角色:">
          <el-select v-model="searchForm.userRole" placeholder="请选择角色">
             <el-option
              v-for="item in roleOptions"
              :key="item.roleId"
              :label="item.roleName"
              :value="item.roleId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态:">
          <el-select v-model="searchForm.userStatus" placeholder="请选择状态">
             <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系方式:">
          <el-input v-model="searchForm.phone" placeholder="联系方式"></el-input>
        </el-form-item>
        <el-form-item>
          <!-- <el-button @click.native="searchClick">
            查询
          </el-button>
           <el-button @click.native="goAddAccount">
            新建
          </el-button> -->
           <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询" :loading="loadingTable"></auth-button>
          </el-form-item>
          <el-form-item>
            <auth-button opt="add" icon="el-icon-plus" @click.native="goAddAccount" label="创建"></auth-button>
          </el-form-item>
      </el-form>
    </el-card>
     <el-card class="tableCard" shadow="never">
      <el-table
        stripe
        style="width:100%"
        align="center"
        v-loading="loadingTable"
        :data="tableData"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          label="序号"
          type="index"
          width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop="userName"
          label="姓名"
          align="center">
        </el-table-column>
        <el-table-column
          prop="userAccount"
          label="账号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="userRoleStr"
          label="角色"
          align="center">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="联系方式"
          align="center">
        </el-table-column>
        <el-table-column
          width="180"
          prop="createTime"
          label="创建时间"
          align="center">
        </el-table-column>
        <el-table-column
          prop="userStatusStr"
          label="状态"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fStatus"
          label="操作"
          align="center"
          fixed="right"
          width="200"
          :context="_self">
          <template slot-scope="scope" v-if="!scope.row.userRoleStr.includes('管理员')">
             <auth-button
              opt="edit"
              type="text"
              @click.native="goAddAccount(scope.row)"
              label="编辑"></auth-button>
              <auth-button
              opt="change_status"
              type="text"
              @click.native="changeStates(scope.row,1)"
              label="启用"
              v-if="scope.row.userStatus!==1"></auth-button>
              <auth-button
              opt="change_status"
              type="text"
              @click.native="changeStates(scope.row,2)"
              label="停用"
              v-if="scope.row.userStatus!==2"></auth-button>
              <auth-button
              opt="delete"
              type="text"
              @click.native="deleteAccount(scope.row)"
              label="删除"
              v-if="scope.row.userStatus===2"></auth-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <pagination :size="paginations.pageSize" @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNo"></pagination>
  </div>
</template>

<script>
import { parseTime } from '@/utils/formatTime'
import datePicker from '@/components/datePicker'
import pagination from '@/components/pagination'
import { getUserAccountList, getAllRoleInfo, delUserAccount, editUserAccount } from '@/api/userAccount.js'
export default {
  components: {
    datePicker,
    pagination
  },
  data () {
    const todayStr = (parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}')).substr(0, 10) + ' 23:59:59'
    const toadyZero = new Date(new Date().getTime() - 3600 * 1000 * 24 * 7)
    const todayZeroStr = parseTime(toadyZero, '{y}-{m}-{d} {h}:{i}:{s}').substr(0, 10) + ' 00:00:00'
    return {
      roleOptions: [],
      statusOptions: [
        {
          label: '启用',
          value: 1
        },
        {
          label: '停用',
          value: 2
        }
      ],
      createTime: [todayZeroStr, todayStr],
      searchForm: {
        userName: '',
        startTime: '',
        endTime: '',
        userAccount: '',
        userRole: '',
        userStatus: '',
        phone: ''
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 10
      },
      loadingTable: false,
      tableData: []
    }
  },
  mounted () {
    this.getAllRoleInfo()
    this.statusOptions.unshift({
      label: '全部',
      value: ''

    })
    this.dateChange(this.createTime)
    this.getList()
  },
  methods: {
    getAllRoleInfo () {
      getAllRoleInfo().then(response => {
        if (+response.error_code === 0) {
          console.log('response: ', response)
          this.roleOptions = response.data
          this.roleOptions.unshift({
            roleName: '全部',
            roleId: ''
          })
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    dateChange (value) {
      if (value !== null) {
        [this.searchForm.startTime, this.searchForm.endTime] = value
      } else {
        [this.searchForm.startTime, this.searchForm.endTime] = ['', '']
      }
    },
    /**
     * @description 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.getList()
    },
    searchClick () {
      this.paginations.pageNo = 1
      this.getList()
    },
    goAddAccount ({ id }) {
      this.$router.push({ path: '/empManage/empManageInfoSet/add-account', query: { id: id || '' } })
    },
    changeStates (item, userStatus) { // userStatus 1为启用 2为禁用
      const params = {
        id: '',
        userAccount: '',
        userName: '',
        userRole: '',
        relatedShopId: '',
        phone: '',
        userStatus: '',
        userId: ''
      }
      Object.keys(params).forEach(key => {
        params[key] = item[key] || params[key]
      })
      params.userStatus = userStatus
      let tips = ''
      if (userStatus === 1) {
        tips = '确定启用该账号吗？'
      } else {
        tips = '确定停用该账号吗？'
      }
      this.$confirm(tips, '', {}).then(() => {
        editUserAccount(params).then(response => {
          if (+response.error_code === 0) {
            this.getList()
            if (userStatus === 1) {
              this.$message.success('启用成功')
            } else {
              this.$message.success('停用成功')
            }
          } else {
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        })
      })
        .catch(e => {
          console.log('e: ', e)
        })
    },
    deleteAccount ({ id }) {
      const params = { id }
      this.$confirm('确定删除该账号吗？', '', {}).then(() => {
        delUserAccount(params).then(response => {
          if (+response.error_code === 0) {
            this.$message.success('删除成功')
            this.getList()
          } else {
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        })
      })
        .catch(e => {
          console.log('e: ', e)
        })
    },
    getList () {
      this.loadingTable = true
      const params = Object.assign(this.searchForm, this.paginations)
      console.log('params: ', params)
      getUserAccountList(params).then(response => {
        this.loadingTable = false
        if (+response.error_code === 0) {
          this.tableData = response.data.list
          this.paginations.count = response.data.total
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
